/* eslint-disable camelcase */
import { get } from 'lodash';

export const searchResults = (state = [], action) => {
  switch (action.type) {
    case 'SET_SEARCH_RESULTS': {
      return get(action, 'payload.parcels', state).filter(
        ({ add_combo, address }) => add_combo || address
      );
    }
    default:
      return state;
  }
};
